import { render, staticRenderFns } from "./ModalUsuarioRegistrado.vue?vue&type=template&id=076dbf1d&scoped=true"
import script from "./ModalUsuarioRegistrado.vue?vue&type=script&lang=js"
export * from "./ModalUsuarioRegistrado.vue?vue&type=script&lang=js"
import style0 from "./ModalUsuarioRegistrado.vue?vue&type=style&index=0&id=076dbf1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076dbf1d",
  null
  
)

export default component.exports